import { ComponentWithPermissions } from '../../../../../../../../../baseComponents/CreateRoutering/types'
import { AnimationReady } from '../../../../../../../../../baseComponents/DoubleTable/types'
import TitleAndWhiteBoxLayout from '../../../../../../../../../baseComponents/Layout/TitleAndWhiteBoxLayout'
import { TwinDictionary } from '../../../../../../../../../utils/globals/dictionary'
import useTwinTranslation from '../../../../../../../../../utils/hooks/useTwinTranslation'
import { MultiSellInvoiceInversedKeys, MultiSellsPendingTypeComponentTy } from '../types'
import TableSellDeliveryNotesPending from './TableSellDeliveryNotesPending'
import TableSellOrdersPending from './TableSellOrdersPending'

type SellsPendingProps = ComponentWithPermissions & AnimationReady & {
    extraData?: TwinDictionary
}

const SellsPending: React.FC<SellsPendingProps> = ({ animationReady, extraData }) => {
    const {t} = useTwinTranslation()
    const dictCustomerSellTy: MultiSellsPendingTypeComponentTy = {
        0: {
            title: t('sellOrdersPending', 'Pedidos pendientes'),
            TableComponent: TableSellOrdersPending,
        },
        1: {
            title: t('sellDeliveryNotesPending', 'Albaranes pendientes'),
            TableComponent: TableSellDeliveryNotesPending,
        },
    }
    const TableComponent = dictCustomerSellTy[extraData?.typeSell as MultiSellInvoiceInversedKeys]?.TableComponent 

    return (
        <TitleAndWhiteBoxLayout title={dictCustomerSellTy?.[extraData?.typeSell as MultiSellInvoiceInversedKeys]?.title || ''}>
            <TableComponent animationReady={animationReady} />
        </TitleAndWhiteBoxLayout>
    )
}

export default SellsPending